import { Component, Input } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TooltipDirective } from '../../tooltip/tooltip.directive';
import { SvgIconComponent } from 'src/app/ui/svg-icon/svg-icon.component';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-discount-tooltip',
  standalone: true,
  imports: [NgIf, TranslateModule, TooltipDirective],
  templateUrl: './discount-tooltip.component.html',
  styleUrls: ['./discount-tooltip.component.scss'],
})
export class DiscountTooltipComponent {
  @Input() appliedDiscount!: {title: string, type: 'catalog' | 'agent' | 'pricebook', message: string | null, discount: number};

  constructor(private translateService: TranslateService) {}

  getIcon(): string {
    switch(this.appliedDiscount.type) {
      case 'catalog':
        return 'catalogs';
      case 'agent':
        return 'briefcase';
      case 'pricebook':
        return 'gift';
    }
  }

  getTitle(): string {
    switch(this.appliedDiscount.type) {
      case 'catalog':
        return this.translateService.instant('Catalogs.catalog_discount');
      case 'agent':
        return this.translateService.instant('Catalogs.agent_extra_discount');
      case 'pricebook':
        return this.translateService.instant('pricebook.rewards.promo') + ' ' + this.appliedDiscount.title + ' ' + this.translateService.instant('pricebook.rewards.applies');
    }
  } 

  getMessage(): string {
    switch(this.appliedDiscount.type) {
      case 'catalog':
        return this.translateService.instant('Catalogs.discount_on_retail_price', { discount: this.appliedDiscount.discount });
      case 'agent':
        return this.translateService.instant('Catalogs.extra_discount_on_retail_price', { discount: this.appliedDiscount.discount });
      case 'pricebook':
        return this.appliedDiscount.message || '';
    }
  }
}
